import { useDispatch, useSelector } from "react-redux";
import { useGridFilter } from "../../../../contexts/GridFilterContext";
import { updateFilter } from "../../../../newapi/global/filter/gridFilterSlice";
import ShDateRangePicker from "../../../theme/ShDateRangePicker";
import { INVOICE_WITHOUT_COST_KEYS } from "../Filter";

const DateRangeFilter = () => {
    const filterKey = INVOICE_WITHOUT_COST_KEYS.DATERANGE.backend_key;
    const dispatch = useDispatch();
    const { index,id } = useGridFilter();

    const filterObject = useSelector((state) => {
        const instance = state.gridFilter.viewInstances[index];
        return instance ? instance[id] : undefined;
    });

    const handleSelect = (value) => {
        if (filterObject && filterObject.filter) {
            dispatch(updateFilter({ index, id, filterKey, 
                value: {
                    startDate: value.startDate,
                    endDate: value.endDate,
                } 
            }));
        }
    };
  
    return (
        <ShDateRangePicker
            startDate={filterObject.filter?.[filterKey]?.startDate}
            endDate={filterObject.filter?.[filterKey]?.endDate}
            select={(value) => {
                handleSelect({
                    startDate:value[0].formattedStartDate,
                    endDate:value[0].formattedEndDate,
                })
            }}
            explicit
        />
    );
};

export default DateRangeFilter;